module.exports = __webpack_public_path__ + "static/img/icon_highlight.149506c6.png";